import type { Spell, SpellOffer, Player } from "./types";
export const SPELL_COPY: Record<
  Spell,
  {
    name: string;
    icon: string;
    group: "Escape" | "Offensive" | "Core";
    description: string;
    detail: string;
  }
> = {
  fireball: {
    name: "Fireball",
    icon: "fireball",
    group: "Core",
    description: "A little fire. A powerful push.",
    detail:
      "Aim a fast fireball to damage opponents and push them toward the lava.",
  },
  dash: {
    name: "Dash",
    icon: "dash",
    group: "Escape",
    description: "Close the gap. Send them flying.",
    detail:
      "Dash toward your cursor, damaging and pushing the first enemy you hit. Pillars stop your dash.",
  },
  teleport: {
    name: "Teleport",
    icon: "teleport",
    group: "Escape",
    description: "Be somewhere else. Instantly.",
    detail:
      "Blink to solid ground in range, including behind pillars. Your momentum stays with you.",
  },
  shield: {
    name: "Deflector",
    icon: "deflector",
    group: "Escape",
    description: "Turn their fire against them.",
    detail:
      "Reflect incoming fireballs and block other hostile spells briefly. Casting ends the deflector. Lava still burns.",
  },
  meteor: {
    name: "Meteor",
    icon: "meteor",
    group: "Offensive",
    description: "Death from above. Mind the delay.",
    detail:
      "A delayed overhead strike damages enemies and pushes them outward. Reaches behind pillars and is unaffected by Dome.",
  },
  dome: {
    name: "Dome",
    icon: "dome",
    group: "Offensive",
    description: "Make every fireball take its time.",
    detail:
      "Slow fireballs inside the field, including your own and your allies’ shots. Meteors are unaffected.",
  },
  lightning: {
    name: "Lightning Strike",
    icon: "lightning_strike",
    group: "Offensive",
    description: "A flash of brilliance. Right there.",
    detail:
      "Strike instantly at your cursor, damaging enemies and pushing them away from the impact.",
  },
};
export const SLOT_KEYS = ["LMB", "RMB", "SPACE", "Q"];
export type PurchaseStatus = { label: string; disabled: boolean };
export function purchaseStatus(
  offer: SpellOffer,
  player: Player | undefined,
  pending: boolean,
): PurchaseStatus {
  if (!player) return { label: "Observers cannot buy", disabled: true };
  if (player.loadout.includes(offer.spell))
    return { label: "Learned", disabled: true };
  if (pending) return { label: "Buying…", disabled: true };
  if (player.ready) return { label: "Build is ready", disabled: true };
  if (!player.loadout.includes(null))
    return { label: "All slots filled", disabled: true };
  if (player.gold < offer.price)
    return {
      label: `Need ${offer.price - player.gold} more gold`,
      disabled: true,
    };
  return { label: `Learn · ${offer.price} gold`, disabled: false };
}
